import React, { useState, useEffect } from "react";
import CommonHeader from "../components/Onboarding/CommonHeader";

import LakeViewIcon from "../images/lake-view-icon.svg";
import ConsumerIcon from "../images/consumer-icon.svg";

import FinancingIcon from "../images/financing-icon.svg";
import PrResIcon from "../images/primary-residence-icon.svg";
import WantadDetailsSkeleton from "../pages/WantadDetailsSkeleton";
import base64 from "base-64";
import {
  getPropertyIcon,
  getTooltipText,
  getCombinedText,
} from "../helpers/getPropertyIcons";
import utf8 from "utf8";
import { BUY, LONG_RENT, SHORT_RENT, LOT_LAND } from "../constants/common";

import { loadPreferredLocationHtml, loadTimeLineHtml } from "../helpers/common";
import { pageURLs } from "../constants/pageURLs";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { getWantAdById, getWantAdDetailsById } from "../services/wantAdService";
import { add } from "lodash";
import { buildWantAdMustHavesHTML } from "../helpers/createWantAd";
import { siteBaseURL } from "../constants/endPoints";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const ShowWantAd = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isFromHomeFeed =
    location.state && location?.state["isFromHomeFeed"] ? true : false;
  searchParams.get("wantAdId");
  const [skeltonLoad, setSkeltonLoad] = useState(true); //
  const id = searchParams.get("wantAdId");
  let decodedId;
  try {
    const bytes = base64.decode(id);
    decodedId = utf8.decode(bytes);
  } catch {}

  const [adDetails, setAdDetails] = useState();
  const adType = _.get(adDetails, "adType", "");
  const propertyType = Number(_.get(adDetails, "prprtyType", ""));
  const PropertyTypeId = _.get(adDetails, "prprtyType", "");
  const subPropertyTypeId = _.get(adDetails, "prptySubTypes", "");
  const adTypeBasedOnProperty = propertyType === 6 ? LOT_LAND : adType;
  const isAdTypeIsLand = adTypeBasedOnProperty === LOT_LAND;
  const nice2Have = _.get(adDetails, "nice2Have", []);
  const mapImage = _.get(adDetails, "mapImg", null);
  const consumerType = adType == BUY ? "Buyer" : "Renter";
  const propertySubTypes = _.get(adDetails, "prptySubTypes", []);
  useEffect(() => {
    if (decodedId) {
      const wantadId = decodedId.split("-"); // Split decoded string for getting want ad id.
      if (wantadId && wantadId.length) {
        getWantAdDetails(wantadId[1]);
      } else {
        navigate(pageURLs.notFound);
      }
    } else {
      navigate(pageURLs.notFound);
    }
  }, []);

  const getWantAdDetails = async (wantAdId) => {
    if (wantAdId) {
      await getWantAdDetailsById(wantAdId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            setAdDetails(responseResult);
            setSkeltonLoad(false);
          } else {
            navigate(pageURLs.notFound);
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    } else {
      navigate(pageURLs.no);
    }
  };

  const loadEachNiceToHave = (section) => {
    const selectedItems =
      nice2Have && nice2Have.filter((item) => item.tab === section);
    return loadNiceToHaveList(selectedItems, section.charAt(0));
  };

  const finalNiceToHaveList = () => {
    const niceToHaveMasterArray = isAdTypeIsLand
      ? ["Views", "Characteristics"]
      : ["Property", "Layout", "Interior", "Exterior", "Other"];
    const finalList =
      niceToHaveMasterArray &&
      niceToHaveMasterArray.map((nh) => {
        return loadEachNiceToHave(nh);
      });
    return finalList;
  };
  const loadNiceToHaveList = (list, uniqueType) => {
    return (
      list &&
      list.map((tl) => {
        const id = _.get(tl, "id");
        const itemText = _.get(tl, "text", "");
        const icon = _.get(tl, "icon", "");
        return (
          <div className="nicetohaves-tag" key={id + uniqueType}>
            <div className="nicetohaves-tag-icon">
              <img
                src={icon ? require("../images/" + icon) : LakeViewIcon}
                alt={icon ? require("../images/" + icon) : LakeViewIcon}
              />
            </div>
            <span>{itemText}</span>
          </div>
        );
      })
    );
  };


  //   let adTypeTile = "Buying";
  //   if (adType === LONG_RENT) {
  //     adTypeTile = "Renting";
  //   } else if (adType === SHORT_RENT) {
  //     adTypeTile = "Staying";
  //   }
  //   return (
  //     <>
  //       <h2>
  //         <span>
  //           {_.get(adDetails, "adTitle", "")},{" "}
  //           {_.get(adDetails, "location", "")}
  //         </span>
  //       </h2>
  //       <div className="want-ad-tag grey-tag-bg">
  //         <span className="tag-icon grey-color-icon">
  //           <svg
  //             width="15"
  //             height="14"
  //             viewBox="0 0 15 14"
  //             fill="none"
  //             xmlns="http://www.w3.org/2000/svg"
  //           >
  //             <path
  //               d="M7.2375 1.1665C7.14658 1.1665 7.05567 1.19604 6.98044 1.25548L3.04229 4.36637C2.53882 4.76387 2.25 5.36044 2.25 6.00266V11.3054C2.25 11.6884 2.56089 11.9998 2.94271 11.9998H5.71354C6.09536 11.9998 6.40625 11.6884 6.40625 11.3054V8.24984C6.40625 8.17345 6.46832 8.11095 6.54479 8.11095H7.93021C8.00668 8.11095 8.06875 8.17345 8.06875 8.24984V9.71034L8.9 8.87701V8.24984C8.9 7.71373 8.46498 7.27761 7.93021 7.27761H6.54479C6.01002 7.27761 5.575 7.71373 5.575 8.24984V11.1665H3.08125V6.00266C3.08125 5.6171 3.25438 5.25955 3.5564 5.02121L7.2375 2.11323L10.9186 5.02121C11.2206 5.25955 11.3938 5.6171 11.3938 6.00266V6.1665C11.6855 6.1665 11.9645 6.21967 12.225 6.31245V6.00266C12.225 5.36016 11.9362 4.76415 11.4327 4.36637L7.49456 1.25548C7.41919 1.19604 7.32842 1.1665 7.2375 1.1665ZM11.3938 6.72206C10.3225 6.72206 9.45417 7.59261 9.45417 8.6665C9.45417 8.80345 9.46842 8.93692 9.4953 9.06581L7.31868 11.2479C7.26659 11.2998 7.2375 11.3707 7.2375 11.4443V12.5554C7.2375 12.7087 7.36136 12.8332 7.51458 12.8332H8.62292C8.77614 12.8332 8.9 12.7087 8.9 12.5554V11.9998H9.45417C9.60739 11.9998 9.73125 11.8754 9.73125 11.7221V11.1665H10.2854C10.4386 11.1665 10.5625 11.0421 10.5625 10.8887V10.4211C10.8146 10.5413 11.0959 10.6109 11.3938 10.6109C12.465 10.6109 13.3333 9.74039 13.3333 8.6665C13.3333 7.59261 12.465 6.72206 11.3938 6.72206ZM11.6708 7.83317C11.977 7.83317 12.225 8.08178 12.225 8.38873C12.225 8.69567 11.977 8.94428 11.6708 8.94428C11.3647 8.94428 11.1167 8.69567 11.1167 8.38873C11.1167 8.08178 11.3647 7.83317 11.6708 7.83317Z"
  //               fill="#15181E"
  //             />
  //           </svg>
  //           OPEN TO {adTypeTile}
  //         </span>
  //       </div>
  //     </>
  //   );
  //   // } else {
  //   //   return (
  //   //     <>
  //   //       <h2>
  //   //         {_.get(adDetails, "adTitle", "Cozy home for small family")}

  //   //       </h2>
  //   //       <h5>{_.get(adDetails, "adType", "") === BUY ? "Buying" : "Renting"} <span class="separator-dot">&bull;{" "}
  //   //       </span> <span class="trailing-text">{_.get(adDetails, "location", "")}</span></h5>
  //   //     </>
  //   //   );
  //   // }
  // };

  const loadAdTitle = () => {
    let adTypeTile = "Buy";
    if (adType === LONG_RENT) {
      adTypeTile = "Rent";
    } else if (adType === SHORT_RENT) {
      adTypeTile = "Stay";
    }
    return (
      <>
        {" "}
        <span className="want-ad-tag align-middle green-tag-bg mb-0 f-size-10">
          {adTypeTile}
        </span>
      </>
    );
  };
  const loadStrengthenDetails = () => {
    if (_.get(adDetails, "isStrengthen", "")) {
      if (adType === BUY) {
        return (
          <>
            {" "}
            <li>
              <span className="list-icn-wrap">
                <img src={PrResIcon} alt={PrResIcon} />
              </span>
              {_.get(adDetails, "prchTypeTxt", "")}
            </li>
            <li>
              <span className="list-icn-wrap">
                <img src={FinancingIcon} alt={FinancingIcon} />
              </span>
              Financing: {_.get(adDetails, "finTypeTxt", "")}
              {(_.get(adDetails, "isPreApprLoan", "") == "Yes" ||
                _.get(adDetails, "isPreApprLoan", "") == 1) &&
                "  - pre approved"}
            </li>
          </>
        );
      } else if (adType === LONG_RENT) {
        return (
          <>
            {" "}
            <li>
              <span className="list-icn-wrap">
                <img src={FinancingIcon} alt={FinancingIcon} />
              </span>
              Credit Score : {_.get(adDetails, "creditScoreText", "")}
            </li>
          </>
        );
      }
    }
  };

  const loadPreferredLocation = () => {
    return loadPreferredLocationHtml(adDetails);
  };

  const loadTimeLine = () => {
    return loadTimeLineHtml(adType, adTypeBasedOnProperty, adDetails);
  };

 
  //   if(garrageSize){
  //     if(garrageSize !== "Any"){
  //       garrageSize =  garrageSize+ '+';
  //     }
  //   }

  //   const budget =   convertToCurrencySystem(
  //     _.get(adDetails, "minBdgt", "")
  //   ) + ' - ' +
  //   convertToCurrencySystem(_.get(adDetails, "maxBdgt", ""))
  //   if (adTypeBasedOnProperty === BUY) {
  //     const minStories = _.get(adDetails, "minStry", "");
  //     const maxStories = _.get(adDetails, "maxStry", "");
  //     const stories =
  //       minStories && maxStories
  //         ? minStories.toString().concat(" - ", maxStories)
  //         : "Any";

  //     const minLtSz = _.get(adDetails, "minLtSz", "");
  //     const maxLtSz = _.get(adDetails, "maxLtSz", "");
  //     const lotSize =
  //       minLtSz && maxLtSz ? minLtSz.toString().concat(" - ", maxLtSz) : "Any";

  //     const isNwCnstctn = _.get(adDetails, "isNwCnstctn", false);
  //     const yrBltMin = _.get(adDetails, "yrBltMin", "");
  //     const yrBltMax = _.get(adDetails, "yrBltMax", "");
  //     const builtYear = isNwCnstctn
  //       ? "New Construction"
  //       : yrBltMin && yrBltMax
  //       ? yrBltMin.toString().concat(" - ", yrBltMax)
  //       : "Any";
  //     let noBathRoom = _.get(adDetails, "noBathRm", "");
  //     let noBedRoom = _.get(adDetails, "noBedRm", "");
  //     if (noBathRoom !== "Any") noBathRoom = noBathRoom + "+";
  //     if (noBedRoom !== "Any") noBedRoom = noBedRoom + "+";
  //     return (
  //       <>
  //         <div className="musthave-wrap">
  //           <h2>Must-haves</h2>
  //           <ul>
  //             <li>
  //               <span className="musthave-label">Budget</span>
  //               <span className="musthave-value">
  //                 {" "}

  //                 ${budget}
  //               </span>
  //             </li>
  //             <li>
  //               <span className="musthave-label">Beds</span>
  //               <span className="musthave-value">{noBedRoom}</span>
  //             </li>
  //             <li>
  //               <span className="musthave-label">Baths</span>
  //               <span className="musthave-value">{noBathRoom}</span>
  //             </li>
  //             <li>
  //               <span className="musthave-label">Sqft</span>
  //               <span className="musthave-value">
  //                 {_.get(adDetails, "sqFtMin", "")} -{" "}
  //                 {_.get(adDetails, "sqFtMax", "")}
  //               </span>
  //             </li>
  //             <li>
  //               <span className="musthave-label">Stories</span>
  //               <span className="musthave-value">
  //                 {/* {" "}
  //               {_.get(adDetails, "minStry", "") !== "" &&
  //               _.get(adDetails, "maxStry", "") !== ""
  //                 ? `${_.get(adDetails, "minStry", "")} - ${_.get(
  //                     adDetails,
  //                     "maxStry",
  //                     ""
  //                   )}`
  //                 : "Any"} */}{" "}
  //                 {stories}
  //               </span>
  //             </li>
  //           </ul>
  //           <ul>
  //             <li>
  //               <span className="musthave-label">Garage spaces</span>
  //               <span className="musthave-value">{garrageSize}</span>
  //             </li>
  //             <li>
  //               <span className="musthave-label">Lot size</span>
  //               <span className="musthave-value">{lotSize}</span>
  //             </li>
  //             <li>
  //               <span className="musthave-label">Year Built</span>
  //               <span className="musthave-value">{builtYear}</span>
  //             </li>
  //           </ul>
  //         </div>
  //       </>
  //     );
  //   } else if (adTypeBasedOnProperty === LONG_RENT) {
  //     let noBathRoom = _.get(adDetails, "noBathRm", "") || "Any";
  //     let noBedRoom = _.get(adDetails, "noBedRm", "") || "Any";
  //     if (noBathRoom && noBathRoom !== "Any") noBathRoom = noBathRoom + "+";
  //     if (noBedRoom && noBedRoom !== "Any") noBedRoom = noBedRoom + "+";

  //     return (
  //       <>
  //         <div className="musthave-wrap">
  //           <h2>Must-haves</h2>
  //           <ul>
  //             <li>
  //               <span className="musthave-label">Budget</span>
  //               <span className="musthave-value text-lowercase">
  //                 {" "}
  //                 ${budget+"/month"}
  //               </span>
  //             </li>
  //             {propertyType !== IS_PRIVATE_ROOM ? (
  //               <>
  //                 <li>
  //                   <span className="musthave-label">Beds</span>
  //                   <span className="musthave-value">{noBedRoom}</span>
  //                 </li>
  //                 <li>
  //                   <span className="musthave-label">Baths</span>
  //                   <span className="musthave-value">{noBathRoom}</span>
  //                 </li>
  //                 <li>
  //                   <span className="musthave-label">Sqft</span>
  //                   <span className="musthave-value">
  //                     {_.get(adDetails, "sqFtMin", "")} -{" "}
  //                     {_.get(adDetails, "sqFtMax", "")}
  //                   </span>
  //                 </li>
  //                 <li>
  //                   <span className="musthave-label">Garage spaces</span>
  //                   <span className="musthave-value">{garrageSize}</span>
  //                 </li>
  //                 <li>
  //                   <span className="musthave-label">Allows large dogs</span>
  //                   <span className="musthave-value">
  //                     {" "}
  //                     {_.get(adDetails, "alwLrgDogs", "") ? "Yes" : "No"}
  //                   </span>
  //                 </li>
  //                 <li>
  //                   <span className="musthave-label">Allows small dogs</span>
  //                   <span className="musthave-value">
  //                     {_.get(adDetails, "alwSmlDogs", "") ? "Yes" : "No"}
  //                   </span>
  //                 </li>
  //                 <li>
  //                   <span className="musthave-label">Allows cats</span>
  //                   <span className="musthave-value">
  //                     {_.get(adDetails, "alwCats", "") ? "Yes" : "No"}
  //                   </span>
  //                 </li>
  //                 <li>
  //                   <span className="musthave-label">ADA Accessible</span>
  //                   <span className="musthave-value">
  //                     {_.get(adDetails, "adaAccess", "") ? "Yes" : "No"}
  //                   </span>
  //                 </li>
  //               </>
  //             ) : (
  //               <>
  //                 {" "}
  //                 <li>
  //                   <span className="musthave-label">ADA Accessible</span>
  //                   <span className="musthave-value">
  //                     {_.get(adDetails, "adaAccess", "") ? "Yes" : "No"}
  //                   </span>
  //                 </li>
  //                 <li>
  //                   <span className="musthave-label">Pets allowed</span>
  //                   <span className="musthave-value">
  //                     {_.get(adDetails, "alwPets", "") ? "All" : "No"}
  //                   </span>
  //                 </li>
  //                 <li>
  //                   <span className="musthave-label">
  //                     Access to private bathroom
  //                   </span>
  //                   <span className="musthave-value">
  //                     {_.get(adDetails, "accsPvtBthRm", null) ? "Yes" : "No"}
  //                   </span>
  //                 </li>
  //               </>
  //             )}
  //           </ul>
  //         </div>
  //       </>
  //     );
  //   } else if (adTypeBasedOnProperty === LOT_LAND) {
  //     let onSiteElectricity = _.get(adDetails, "onSiteElec", "");
  //     // ----------------------------------commented on 05-03-2023----------------------------------//
  //     // if (onSiteElectricity === true) {
  //     //   onSiteElectricity = "Yes";
  //     // } else if (onSiteElectricity === false) {
  //     //   onSiteElectricity = "No";
  //     // } else {
  //     //   onSiteElectricity = "";
  //     // }
  //     // ----------------------------------commented on 05-03-2023----------------------------------//
  //     if (onSiteElectricity === 1) {
  //       onSiteElectricity = "Yes";
  //     } else if (onSiteElectricity === 0) {
  //       onSiteElectricity = "No";
  //     } else {
  //       onSiteElectricity = "Any";
  //     }

  //     const lotType = _.get(adDetails, "lotType", null);
  //     const lotTypeText =
  //       lotType && (lotType === 1 ? RURAL : IN_CITY_LIMITS);

  //     const roadType = _.get(adDetails, "roadType", null);
  //     const rdTypText =
  //       roadType && (roadType === 1 ? "City roads" : "Private drive");

  //     const waterSupply = _.get(adDetails, "waterSupply", "");
  //     const wSText =
  //       waterSupply &&
  //       (waterSupply === 1 ? "Domestic water supply" : "Drilled well");

  //     const wasteWtrSys = _.get(adDetails, "wasteWtrSys", null);
  //     const wWSysText =
  //       wasteWtrSys && (wasteWtrSys === 1 ? "Sewer" : "Septic system");
  //     return (
  //       <>
  //         <div className="musthave-post-wrap">
  //           <h2>Must-haves</h2>
  //           <ul className="ulw-100">
  //             <li className="w-14">
  //               <span className="musthave-label text-capitalize list-item-color">
  //                 Budget
  //               </span>
  //               <span className="musthave-value">
  //                 {" "}
  //                 ${budget}
  //               </span>
  //             </li>
  //             <li className="w-14">
  //               <span className="musthave-label text-capitalize list-item-color">
  //                 Acreage
  //               </span>
  //               <span className="musthave-value">
  //                 {_.get(adDetails, "acreageMin", "")} -{" "}
  //                 {_.get(adDetails, "acreageMax", "")}
  //               </span>
  //             </li>
  //             <li className="w-14">
  //               <span className="musthave-label text-capitalize list-item-color">
  //                 Lot Type
  //               </span>
  //               <span className="musthave-value">{lotTypeText || "Any"}</span>
  //             </li>
  //             <li className="w-14">
  //               <span className="musthave-label text-capitalize list-item-color">
  //                 Road Type
  //               </span>
  //               <span className="musthave-value">
  //                 {rdTypText ?? "Any"}

  //                 {_.get(adDetails, "isPrvtDrInst", "") ? ", Installed" : ""}
  //               </span>
  //             </li>
  //             <li className="w-14">
  //               <span className="musthave-label text-capitalize list-item-color">
  //                 Electricity
  //               </span>
  //               <span className="musthave-value">{onSiteElectricity}</span>
  //             </li>
  //             <li className="w-14">
  //               <span className="musthave-label text-capitalize list-item-color">
  //                 Water Supply
  //               </span>
  //               <span className="musthave-value">{wSText ?? "Any"}</span>
  //             </li>
  //             <li className="w-16">
  //               <span className="musthave-label text-capitalize list-item-color">
  //                 Wastewater
  //               </span>
  //               <span className="musthave-value">
  //                 {wWSysText ?? "Any"}
  //                 {_.get(adDetails, "isSepTankInst", "") ? ", Installed" : ""}
  //                 {_.get(adDetails, "isSepTankAppr", "") ? ", Approved" : ""}
  //               </span>
  //             </li>
  //           </ul>{" "}
  //         </div>
  //       </>
  //     );
  //   } else if (adTypeBasedOnProperty === SHORT_RENT) {
  //     let noBathRoom = _.get(adDetails, "noBathRm", "") || "Any";
  //     let noBedRoom = _.get(adDetails, "noBedRm", "") || "Any";
  //     if (noBathRoom && noBathRoom !== "Any") noBathRoom = noBathRoom + "+";
  //     if (noBedRoom && noBedRoom !== "Any") noBedRoom = noBedRoom + "+";
  //     let allowPets = _.get(adDetails, "alwPets", "");
  //     let Dates = "";
  //     if (
  //       _.get(adDetails, "startDate", "") &&
  //       _.get(adDetails, "endDate", "")
  //     ) {
  //       Dates =
  //         formateDate(_.get(adDetails, "startDate", ""), "mm/dd/yyyy") +
  //         " - " +
  //         formateDate(_.get(adDetails, "endDate", ""), "mm/dd/yyyy");
  //     } else {
  //       Dates =
  //         durationForFlexibleDate(_.get(adDetails, "duration", "")) +
  //         " in " +
  //         monthNameForFlexibleDate(_.get(adDetails, "month", ""));
  //     }

  //     return (
  //       <>
  //         <div className="musthave-wrap">
  //           <h2>Must-haves</h2>
  //           <ul>
  //             <li>
  //               <span className="musthave-label">Budget</span>
  //               <span className="musthave-value text-lowercase">
  //                 {" "}
  //                 ${budget +
  //                   "/night"}
  //               </span>
  //             </li>
  //             {propertyType !== IS_PRIVATE_ROOM ? (
  //               <>
  //                 <li>
  //                   <span className="musthave-label">Beds</span>
  //                   <span className="musthave-value">{noBedRoom}</span>
  //                 </li>
  //                 <li>
  //                   <span className="musthave-label">Baths</span>
  //                   <span className="musthave-value">{noBathRoom}</span>
  //                 </li>
  //               </>
  //             ) : (
  //               <>
  //                 <li>
  //                   <span className="musthave-label">ADA Accessible</span>
  //                   <span className="musthave-value">
  //                     {" "}
  //                     {_.get(adDetails, "adaAccess", "") ? "Yes" : "No"}
  //                   </span>
  //                 </li>
  //                 <li>
  //                   <span className="musthave-label">Pets allowed</span>
  //                   <span className="musthave-value">
  //                     {allowPets ? "All" : "No"}
  //                   </span>
  //                 </li>
  //               </>
  //             )}

  //             <li>
  //               <span className="musthave-label">Dates</span>
  //               <span className="musthave-value">{Dates}</span>
  //             </li>
  //           </ul>
  //           {propertyType !== IS_PRIVATE_ROOM && (
  //             <ul>
  //               <li>
  //                 <span className="musthave-label">ADA Accessible</span>
  //                 <span className="musthave-value">
  //                   {" "}
  //                   {_.get(adDetails, "adaAccess", "") ? "Yes" : "No"}
  //                 </span>
  //               </li>
  //               <li>
  //                 <span className="musthave-label">Pets allowed</span>
  //                 <span className="musthave-value">
  //                   {allowPets ? "All" : "No"}
  //                 </span>
  //               </li>
  //             </ul>
  //           )}
  //         </div>
  //       </>
  //     );
  //   }
  // };

  // const usePageMeta = (title, description) =>{
  //   const defaultTitle = "app-name";
  //   const defaultDesc = "meta description";

  //   useEffect(() => {
  //       document.title = title || defaultTitle;
  //       document.querySelector("meta[name='og:description']").setAttribute("content", description || defaultDesc);
  //   }, [defaultTitle, title, defaultDesc, description]);
  // };

  // const renderTooltip = (props) => (
  //   <Tooltip id="button-tooltip" placement="bottom-start" className="custom-tooltip" {...props}>
  //     {adType===1 ? getTooltipText(PropertyTypeId):
  //       subPropertyTypeId && subPropertyTypeId.length > 0 &&
  //       getCombinedText(subPropertyTypeId)
  //     }
  //   </Tooltip>
  // );

  const renderTooltip = (props) => (
    <Tooltip
      id="button-tooltip"
      placement="bottom-start"
      className="custom-tooltip"
      {...props}
    >
      {adType === BUY
        ? getTooltipText(propertyType)
        : propertySubTypes &&
          propertySubTypes.length > 0 &&
          getCombinedText(propertySubTypes)}
    </Tooltip>
  );

  const loadAdMustHaves = () => {
    return buildWantAdMustHavesHTML({
      adType: adType,
      adTypeBasedOnProperty: adTypeBasedOnProperty,
      formValues: adDetails,
    });
  };
  const isNiceToHaveExist = nice2Have.length > 0;
  return (
    <>
      {skeltonLoad ? (
        <WantadDetailsSkeleton />
      ) : (
        <>
          <div className="outer-wrap position-relative mw-1168">
            <CommonHeader  />
            {isFromHomeFeed && (
              <a
                role="button"
                className="bottom-back-btn mb-24 d-inline-block"
                onClick={() => navigate(-1)}
              >
                <span class="left-arrow">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.73359 3.59957C6.92886 3.79483 6.92886 4.11142 6.73359 4.30668L3.54048 7.49979H13.6667C13.9429 7.49979 14.1667 7.72365 14.1667 7.99979C14.1667 8.27593 13.9429 8.49979 13.6667 8.49979H3.54048L6.73359 11.6929C6.92886 11.8882 6.92886 12.2048 6.73359 12.4C6.53833 12.5953 6.22175 12.5953 6.02649 12.4L1.97982 8.35335C1.88605 8.25958 1.83337 8.1324 1.83337 7.99979C1.83337 7.86718 1.88605 7.74001 1.97982 7.64624L6.02649 3.59957C6.22175 3.40431 6.53833 3.40431 6.73359 3.59957Z"
                      fill="#205ECA"
                    ></path>
                  </svg>
                </span>
                Back
              </a>
            )}
            <div className="row">
              <div className="col-12 col-md-7 ps-md-3 col-lg-8 ps-lg-3 col-xl-9 ps-xl-2">
                <div className="wantad-confirmation-wrap mb-4">
                  <div className="confirmation-top-sec d-md-flex justify-content-between">
                    <div className="long-txt-fix">
                      <div class="confirm-sub-title mb-1">
                        I'm looking to:
                        {loadAdTitle()}
                      </div>
                      <h2>
                        {_.get(
                          adDetails,
                          "adTitle",
                          "Cozy home for small family"
                        )}{" "}
                      </h2>
                      <span className="trailing-txt">
                        Within {_.get(adDetails, "mapRadius", "")} mi of{" "}
                        {_.get(adDetails, "city", "")}
                        {", "}
                        {_.get(adDetails, "state", "")}
                      </span>
                    </div>
                  </div>
                  <div className="confirm-map-wrap">
                    <div className="property-tile w-auto">
                      <OverlayTrigger
                        placement="bottom-start"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                      >
                        <div className="property-tile w-auto">
                          {adType === BUY ? (
                            <img
                              src={getPropertyIcon(propertyType)}
                              alt={getPropertyIcon(propertyType)}
                              className="property-icon-img"
                            />
                          ) : (
                            propertySubTypes &&
                            propertySubTypes.length > 0 &&
                            propertySubTypes.map((subtype) => {
                              return (
                                <img
                                  src={getPropertyIcon(subtype)}
                                  alt={getPropertyIcon(subtype)}
                                  className="property-icon-img"
                                />
                              );
                            })
                          )}
                        </div>
                      </OverlayTrigger>
                    </div>
                    <img
                      src={mapImage + "?" + Math.random().toString(36)}
                      alt={mapImage}
                      className="disp-map-img"
                    />
                  </div>
                  {loadAdMustHaves()}

                  {isNiceToHaveExist ? (
                    <div className="nicetohaves-wrap">
                      <h2>Nice-to-haves</h2>
                      <div className="nicetohaves-inner-wrap">
                        {finalNiceToHaveList()}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {_.get(adDetails, "adDesc", "") ? (
                    <div className="additional-details-wrap">
                      <h2>Additional details</h2>
                      <p>{_.get(adDetails, "adDesc", "")}</p>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="buyer-info">
                    {/* <h2>{consumerType} Information</h2> */}
                    <h2>Additional details</h2>
                    <ul>
                      <li>
                        <span className="list-icn-wrap">
                          <img src={ConsumerIcon} />
                        </span>
                        {_.get(adDetails, "isAgentCreated", "") == 1
                          ? " Represented by Agent"
                          : consumerType}
                      </li>
                      {adType == BUY &&
                        _.get(adDetails, "isAgentCreated", "") == 1 &&
                        _.get(adDetails, "agentCompenation", "") && (
                          <li>
                            <span className="list-icn-wrap">
                              <img src={ConsumerIcon} />
                            </span>
                            Minimum requested buyer's agent compensation:{" "}
                            {_.get(adDetails, "agentCompenation", "")
                              ? _.get(adDetails, "agentCompenation", "")
                              : 0}
                            %
                          </li>
                        )}

                      {loadTimeLine()}
                      {loadPreferredLocation()}
                      {loadStrengthenDetails()}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ShowWantAd;
